import { useCallback } from 'react';
import t from 'common/i18n';
import { StyledCombobox } from '../../../../common/combobox.jsx';
import { useFilterParams } from '../../selectors';
import { getSelectedItemByValue } from '../../utils';
import { ORIENTATION_OPTIONS } from '../../filterConsts';
import { SectionBox } from './Filters.styles';

export default ({ handleSearch, source, isMulti = false }) => {
  const { orientations } = useFilterParams(source);
  const options = ORIENTATION_OPTIONS.map((value) => ({ label: t(`${source}.filters.orientation.${value}`), value }));

  const selectedItem = getSelectedItemByValue(orientations, options, isMulti);

  const filterChange = useCallback(
    (item) => {
      handleSearch({
        filters: {
          orientations: isMulti ? (item?.map((item) => item.value) ?? []) : item?.value,
        },
      });
    },
    [handleSearch, isMulti]
  );

  return (
    <SectionBox data-test="orientation-section">
      <label>{t(`${source}.filters.orientation.label`)}</label>
      <StyledCombobox
        size="md"
        isMulti={isMulti}
        isSearchable={false}
        placeholder={t(`${source}.select`)}
        options={options}
        value={selectedItem}
        onChange={filterChange}
      />
    </SectionBox>
  );
};
